<template>
  <v-main>
    <v-app
      id="home-view"
      light
      style="background-color: #FAFAFA"
    >      
      <toolbar></toolbar>
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </v-app>
  </v-main>
</template>

<script>

import toolbar from '@/components/Toolbar';

export default {
  name: 'HomeView',
  components:{
    toolbar
  }
}
</script>

<style>
.v-btn--outlined .v-btn__content .v-icon, .v-btn--round .v-btn__content .v-icon {
    color:rgba(0,0,0,.54)
}
</style>
